import { Box, Typography } from '@mui/material'

const DividerComponent = ({ label, sx }) => {
  return (
    <Box sx={sx}>
      <Box
        sx={theme => ({
          display: 'inline-flex',
          alignItems: 'center',
          borderLeft: `4px solid ${theme.palette.secondary.main}`,
          pl: 4,
        })}>
        <Typography
          variant="h2"
          gutterBottom
          fontWeight={600}
          sx={theme => ({
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.text.primary,
            my: 2,
          })}>
          {label}
        </Typography>
      </Box>
    </Box>
  )
}

export default DividerComponent
